import {subdebug} from '@sanity/cli-core'

export const buildDebug = subdebug('build')
